export default __webpack_public_path__ + "static/media/paycard-telecomm.5a18c1f0.png";